/**
 * The Build Itinerary wizard's flow-step tours. Each step component runs its own tour, so it
 * mounts and unmounts with that step. They auto-run the first time only and are not in the Guided
 * tours list, since they only make sense mid-wizard. In setup mode the wizard starts at step 2, so
 * the event tour never mounts.
 */
export const BUILD_ITINERARY_FEATURE = "build-itinerary";

export const BUILD_ITINERARY_TOURS = {
  event: "build-itinerary.event",
  matchTeams: "build-itinerary.match-teams",
  followPlayers: "build-itinerary.follow-players",
  pitchers: "build-itinerary.pitchers",
  assign: "build-itinerary.assign",
} as const;
